import {
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, Validators } from '@angular/forms';
import { FormInputRadioComponent } from '../radio/form-input-radio.component';
import { FormInputRadioItemInterface } from '../radio/form-input-radio.interface';

@Component({
  selector: 'shared-form-adding-by-group',
  templateUrl: './adding-by-group.component.html',
  styleUrls: ['./adding-by-group.component.css'],
  imports: [FormsModule, FormInputRadioComponent],
})
export class AddingByGroupComponent implements OnInit {
  radioButtonData = input.required<FormInputRadioItemInterface[]>();

  readonly addingByChange = output<string>();

  addingByControl: FormControl = new FormControl('', [Validators.required]);

  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  constructor() {
    this.addingByControlValueChanges();
  }

  ngOnInit(): void {
    this.addingByControl.setValue(this.radioButtonData()?.[0]?.value);
  }

  private addingByControlValueChanges(): void {
    this.addingByControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.addingByChange.emit(value);
      });
  }
}
